module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"date_field":{"label":"Datum"}},"en":{"date_field":{"label":"Date"}}}')
  delete Component.options._Ctor
}
